import { useCookies } from 'react-cookie';
import { useSelector } from 'react-redux';
import { isFeatureEnabled } from '../features/SwitchableFeature/SwitchableFeature';
import { useLayoutEffect } from 'react';
import { CART } from '../features/SwitchableFeature/SwitchableFeature.definitions';
import { isGTAGEnabled, isGTMEnabled } from '../utils/isGTMEnabled';
import { isProduction } from '../utils/isProduction';
import { replayEvents } from '../client/eventCollector';
import { cleanHydrationEventListeners } from '../client/deferredHydration';
import { initGTMScript, injectGTAGScript } from '../utils/GoogleTagUtils';

const injectClarityScript = () => {
  const clarityScript = document.createElement('script');
  clarityScript.innerHTML = `
  (function(c,l,a,r,i,t,y){
      c[a]=c[a]||function(){(c[a].q=c[a].q||[]).push(arguments)};
      t=l.createElement(r);t.async=1;t.src="https://www.clarity.ms/tag/"+i;
      y=l.getElementsByTagName(r)[0];y.parentNode.insertBefore(t,y);
  })(window, document, "clarity", "script", "oiyy8jiklo");
  `;
  document.querySelector('head').appendChild(clarityScript);
};
/**
 * Inject third party scripts like GTM, analytics on client side
 */
const useClientScriptInjector = () => {
  const [cookies] = useCookies(['enabledFeatureFlags']);
  const config = useSelector(({ config }) => config);

  const marketplaceVersion = isFeatureEnabled(cookies, config, CART);
  useLayoutEffect(() => {
    setTimeout(() => {
      //todo: If replayEvents launched without setTimeout, it is called recursively
      cleanHydrationEventListeners();
      replayEvents();

      const mapScript = document.createElement('script');
      mapScript.src = `https://maps.googleapis.com/maps/api/js?key=${process.env.REACT_APP_GOOGLE_MAP_API_KEY}&libraries=places,geometry`;
      mapScript.async = true;
      mapScript.defer = true;
      document.querySelector('body').appendChild(mapScript);

      //add GTM to the app
      //REACT_APP_GTM_ID is added as a new tag for MP webshop
      if (isGTMEnabled) {
        initGTMScript();
        injectClarityScript();
      } else if (isGTAGEnabled) {
        injectGTAGScript();
        injectClarityScript();
      }

      if (isProduction) {
        //script apm rum on localhost, but trigget on all (dev/stage/prod) domains
        const APMRUMScript = document.createElement('script');
        const versionPrefix = marketplaceVersion ? 'mp-' : '';
        const miabClientServiceName = `miab-client-${versionPrefix}${process.env.REACT_APP_WEBSITE_DOMAIN}`.replace(
          /[:\.]/g,
          '-'
        );
        APMRUMScript.innerHTML = `
        ;(function(d, s, c) {
            var j = d.createElement(s),
              t = d.getElementsByTagName(s)[0]

            j.src = '${process.env.REACT_APP_BASE_URL}/elastic-apm-rum.umd.min-5.16.1.js'
            j.onload = function() {elasticApm.init(c)}
            t.parentNode.insertBefore(j, t)
          })(document, 'script', {environment: 'production', serviceName: '${miabClientServiceName}', serverUrl: 'https://miab-monitoring.apm.eu-west-1.aws.found.io'})
        `;

        document.querySelector('head').appendChild(APMRUMScript);
      }
    }, 0);
  }, []);
};

export default useClientScriptInjector;
